/**
 * Module definition for export module. The export module manages
 * the application's top-level export view (i.e., /export).
 *
 * @module routes.export
 */

angular.module('routes.export', [
  'routes.export.ExportController',
  'routes.export.ExportPayloadResolver'
])
.config(
  [
    '$stateProvider',
    function ($stateProvider) {
      'use strict';

      $stateProvider
        .state('routes.export', {
          url: '/export',
          templateUrl: 'routes/export/export.html',
          controller: 'ExportController',
          params: {},
          resolve: {
            exportPayload: [
              'ExportPayloadResolver',
              '$stateParams',
              'newmanPayload',
              function (ExportPayloadResolver, $stateParams, newmanPayload) {
                return new ExportPayloadResolver($stateParams, newmanPayload);
              }
            ]
          }
        }
      );
    }
  ]
);
